module.exports = __webpack_public_path__ + "static/media/photo-05-cgv.a997b8f5.png";